import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import quotingActions from './quotingActions';
import userActions from '../user/userActions';
import policyActions from '../policy/policyActions';

import { Button } from '../components/buttons';
import { TextInput } from '../components/forms';
import { Page, PageContent, PageHeader, Spinner } from '../components/common';

interface Props {
	actions: any;
	className?: string;
	history: any;
	user: UserDetails;
	customerPolicy: CustomerPolicy;
	isHardDeclined: DeclineCheckerDto;
}
interface State {
	saving: boolean;
	showSaveMsg: boolean;
}

class QuotingDeclined extends React.Component<Props, State> {

	state = {
		saving: false,
		showSaveMsg: false,
	};

	componentWillUnmount() {
		this.resetAllQuestionnaireData();
		this.props.history.push('/');
	}

	resetAllQuestionnaireData() {
		this.props.actions.resetUser();
		this.props.actions.resetCustomerDetails();
		this.props.actions.resetQuestionnaire();
		this.props.actions.resetCustomerPolicy();
	}

	onUserChange = (e: any) => {
		const user = {
			...this.props.user,
			[e.target.name]: e.target.value
		};

		this.props.actions.setUser(user);
	}

	onPhoneKeyUp = (e: any) => {
		let phone = e.target.value;
		phone = phone
			.match(/\d*/g)
			.join('')
			.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
			.slice(1)
			.join('-')
			.replace(/-*$/g, '');

		const user = {
			...this.props.user,
			[e.target.name]: phone
		};

		this.props.actions.setUser(user);
	}

	onSave = () => {
		this.setState({saving: true});
		const softDeclinedUser = {...this.props.user};
		this.props.actions.updateSoftDeclinedUser(softDeclinedUser, this.props.customerPolicy.id)
		.then(() => this.setState({showSaveMsg: true, saving: false}));
	}

	onHardDeclineEmailSave = () => {
		this.setState({saving: true});
		const hardDeclinedQCUser = {...this.props.user};
		this.props.actions.saveUser(hardDeclinedQCUser)
		.then(() => this.setState({showSaveMsg: true, saving: false}));
	}

	render() {
		return (
			<Page>
				<PageContent sectionClassName="text-center">
					{this.props.isHardDeclined.isDeclined ? 
						(this.props.isHardDeclined.isQCDeclined ? (
							<div>
							<PageHeader title="Nous sommes désolés." isCentered={true} className="text-secondary">
								<div className="lead mb-0">
									<p>
									Mosaic Life n’est pas couramment disponible au Québec.
									Nous travaillons vers l’ouverture de notre site en français,
									ainsi que la traduction de notre police d’assurance. 
									Si vous désirez que nous vous laissions savoir quand nos produits
									seront disponibles au Québec veuillez nous provenir votre adresse courriel ci-dessous. 
									</p>
								</div>
							</PageHeader>
							{this.state.showSaveMsg ? (
								<div className="row">
									<div className="col-md-8 col-lg-6 mx-auto">	
										<p className="lead">Merci.</p>
									</div>
								</div>
							) :
							(<div className="row">
									<div className="col-md-8 col-lg-6 mx-auto">								
											<TextInput
												labelText="Email"
												name="email"
												onChange={this.onUserChange}
												value={this.props.user.email}
											/>
										<Button onClick={this.onHardDeclineEmailSave} className="btn-primary" disabled={this.state.saving}>
											Contactez moi
											{this.state.saving && <Spinner />}
										</Button>
									</div>
								</div>
							)}
						</div>
						) : (
							<PageHeader title="Sorry." isCentered={true} className="text-secondary">
								<div className="lead mb-0">
									<p>
										Unfortunately, at this time, we are not able to provide you with a life insurance quote 
										based on your answers to the  questionnaire.
									</p>
								</div>
							</PageHeader>
					)) : (
					<div>
						<PageHeader title="Let's speak." isCentered={true} className="text-secondary">
							<div className="lead mb-0">
								<p>
									Based on your answers to the questionnaire, we need a bit more information from you in 
									order to process your application.  Please enter your phone number and validate your email below and someone 
									from Mosaic Life will contact you shortly.
								</p>
							</div>
						</PageHeader>
						{this.state.showSaveMsg ? (
							<div className="row">
								<div className="col-md-8 col-lg-6 mx-auto">	
									<p className="lead">Thanks. We'll contact you shortly.</p>
								</div>
							</div>
						) : (
							<div className="row">
								<div className="col-md-8 col-lg-6 mx-auto">								
									{/* Has to use hardDeclinedChecker here since both soft&hard declined checkers will be set to true
									on server side after first api call*/}
										<TextInput
											labelText="Please enter your phone number"
											name="phoneNumber"
											onChange={this.onUserChange}
											onKeyUp={this.onPhoneKeyUp}
											value={this.props.user.phoneNumber}
										/>
										<TextInput
											labelText="Email"
											name="email"
											onChange={this.onUserChange}
											value={this.props.user.email}
										/>
									<Button onClick={this.onSave} className="btn-primary" disabled={this.state.saving}>
										Contact Me
										{this.state.saving && <Spinner />}
									</Button>
								</div>
							</div>
						)}
					</div>)}
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		user: state.user.user,
		customerPolicy: state.policy.customerPolicy,
		isHardDeclined: state.policy.isHardDeclined
	};
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...quotingActions, ...userActions, ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(QuotingDeclined);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/QuotingDeclined.tsx